export const CLEAR_EVENTS = "CLEAR_EVENTS";
export const CREATE_EVENTS_BEGIN = "CREATE_EVENTS_BEGIN";
export const CREATE_EVENTS_FAILURE = "CREATE_EVENTS_FAILURE";
export const CREATE_EVENTS_SUCCESS = "CREATE_EVENTS_SUCCESS";

export const BULK_CREATE_EVENTS_BEGIN = "BULK_CREATE_EVENTS_BEGIN";
export const BULK_CREATE_EVENTS_FAILURE = "BULK_CREATE_EVENTS_FAILURE";
export const BULK_CREATE_EVENTS_SUCCESS = "BULK_CREATE_EVENTS_SUCCESS";

export const FETCH_EVENTS_BEGIN = "FETCH_EVENTS_BEGIN";
export const FETCH_EVENTS_SUCCESS = "FETCH_EVENTS_SUCCESS";
export const FETCH_EVENTS_FAILURE = "FETCH_EVENTS_FAILURE";

export const FETCH_EVENTS_SCHEMA_BEGIN = "FETCH_EVENTS_SCHEMA_BEGIN";
export const FETCH_EVENTS_SCHEMA_SUCCESS = "FETCH_EVENTS_SCHEMA_SUCCESS";
export const FETCH_EVENTS_SCHEMA_FAILURE = "FETCH_EVENTS_SCHEMA_FAILURE";

export const DELETE_EVENTS_BEGIN = "DELETE_EVENTS_BEGIN";
export const DELETE_EVENTS_SUCCESS = "DELETE_EVENTS_SUCCESS";
export const DELETE_EVENTS_FAILURE = "DELETE_EVENTS_FAILURE";

export const BULK_DELETE_EVENTS_BEGIN = "BULK_DELETE_EVENTS_BEGIN";
export const BULK_DELETE_EVENTS_SUCCESS = "BULK_DELETE_EVENTS_SUCCESS";
export const BULK_DELETE_EVENTS_FAILURE = "BULK_DELETE_EVENTS_FAILURE";

export const UPDATE_EVENTS_BEGIN = "UPDATE_EVENTS_BEGIN";
export const UPDATE_EVENTS_SUCCESS = "UPDATE_EVENTS_SUCCESS";
export const UPDATE_EVENTS_FAILURE = "UPDATE_EVENTS_FAILURE";

export const BULK_UPDATE_EVENTS_BEGIN = "BULK_UPDATE_EVENTS_BEGIN";
export const BULK_UPDATE_EVENTS_SUCCESS = "BULK_UPDATE_EVENTS_SUCCESS";
export const BULK_UPDATE_EVENTS_FAILURE = "BULK_UPDATE_EVENTS_FAILURE";

export const UPDATE_SELECTED_FIELD_USER = "UPDATE_SELECTED_FIELD_USER";
export const TRANSFER_EVENTS_BEGIN = "TRANSFER_EVENTS_BEGIN";
export const TRANSFER_EVENTS_SUCCESS = "TRANSFER_EVENTS_SUCCESS";
export const TRANSFER_EVENTS_FAILURE = "TRANSFER_EVENTS_FAILURE";
export const SWAP_EVENTS_BEGIN = "SWAP_EVENTS_BEGIN";
export const SWAP_EVENTS_SUCCESS = "SWAP_EVENTS_SUCCESS";
export const SWAP_EVENTS_FAILURE = "SWAP_EVENTS_FAILURE";
